export default {
  name: "AccountLoged",
  data() {
    return {
      dataUser: null,
    };
  },
  mounted() {
    this.getUserLogado();
  },
  methods: {
    getUserLogado() {
      if (localStorage.key("X_ACCESS_TOKEN")) {
        let token = localStorage.getItem("X_ACCESS_TOKEN");
        var base64Url = token.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        let json = JSON.parse(jsonPayload);
        this.dataUser = {
          ID: json.ID,
          NOME: json.unique_name,
          NOMEUSUARIO: json.Nome,
          CLAIMS: json.Claims.split(";"),
          // NOVASENHA: json.NovaSenha.split(";"),
        };
        return this.dataUser;
      }
    },
    hasClaim(value, pag = false) {
      let getvalue = false;
      if (value.indexOf("-") > 0) getvalue = true;
      if (this.dataUser == null) return false;
      if (
        this.dataUser.CLAIMS.find((Element) => {
          if (getvalue) return Element == value;
          else return Element.split("-")[0] === value;
        })
      )
        return true;
      if (pag) this.trocaConteudo();
      return false;
    },
    trocaConteudo() {
      this.$router.push("/semacesso");
    },
  },
};
